export var CDN_PATH = process.env.REACT_APP_ASSETS_CDN_PATH;
export var PROFILE_DOMAIN = process.env.REACT_APP_PROFILE_DOMAIN;
export var YANDEX_API_KEY = process.env.REACT_APP_YANDEX_API_KEY;
